import invoicingRoutes from './routes'

/* @ngInject */
const consultRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(invoicingRoutes.index.path, {
      url: invoicingRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'invoicingCtrl',
      data: {
        pageTitle: 'Facturation',
      },
    })
}

export default consultRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/invoicing/invoicing.routes.js